
/* eslint-disable camelcase */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import DialogSelecedtName from './components/BranchDialog.vue';
import { delimiter } from 'path';
import { branchStatistics, exportStatistics, cycleCheckList } from '@/api/cyclCheck';
@Component({
  name: 'BranchOrderServicer',
  components: {
    DialogSelecedtName
  }
})
export default class extends Vue {
  private checkboxDisabled=false;
  private formSearch:any = {
    branchCompanyId: '',
    name: '',
    containBranch: false,
    time: [],
    event: '',
    state: '',
    startTime: '',
    endTime: ''

  }
  private listQuery = {
    page: 1,
    size: 10,
    total: 0
  }
  private selecedtNameVisible = false
  private selectedNameReadonly = false
  @Watch('selecedtNameVisible', {
    immediate: true
  })toggleVisible(val: boolean) {
    if (val) {
      this.selectedNameReadonly = true;
    } else {
      this.selectedNameReadonly = false;
    }
  }

  created() {
    this.getCheckList(UserModule.getCompanyId);
    if (Object.keys(this.$route.query).length !== 0) {
      let pamars:any = JSON.parse(this.$route.query.pamars.toString());
      this.checkboxDisabled = pamars.checkboxDisabled;
      let containBranch = pamars.containBranch;
      let state = pamars.last_check_state.toString();
      let startTime = '';
      let endTime = '';
      if (pamars.startTime) {
        startTime = pamars.startTime + '000';
        this.formSearch.time.push(startTime);
      }
      if (pamars.endTime) {
        endTime = pamars.endTime + '000';
        this.formSearch.time.push(endTime);
      }
      this.formSearch.containBranch = containBranch;
      // this.formSearch.state = state;
      this.formSearch.startTime = startTime;
      this.formSearch.endTime = endTime;
      if (pamars.branchCompanyId) {
        this.formSearch.name = pamars.name;
        this.formSearch.branchCompanyId = pamars.branchCompanyId;
      }
      if (pamars.event) {
        // this.formSearch.event = pamars.event;
        this.$set(this.formSearch, 'event', pamars.event);
      }
    }
    this.getRecordList();
  }
  private clearCompany() {
    this.checkboxDisabled = true;
    this.formSearch.containBranch = false;
    this.formSearch.branchCompanyId = '';
  }
  private handleSearch() {
    if (this.formSearch.time && this.formSearch.time.length > 0) {
      this.formSearch.startTime = this.formSearch.time[0].toString();
      this.formSearch.endTime = this.formSearch.time[1].toString();
    }
    this.getRecordList();
  }
  private restData() {
    this.checkboxDisabled = true;
    this.listQuery = {
      page: 1,
      size: 10,
      total: 0
    };
    this.formSearch = {
      branchCompanyId: '',
      name: '',
      containBranch: false,
      time: [],
      event: '',
      state: '',
      startTime: '',
      endTime: ''

    };
    this.getRecordList();
  }

  // 导出Excel
  handleExport() {
    let params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      branch_company_id: this.formSearch.branchCompanyId ? this.formSearch.branchCompanyId : UserModule.getCompanyId,
      contain_branch: this.checkboxDisabled ? '1' : this.formSearch.containBranch ? '1' : '0',
      cycle_check_id: this.formSearch.event ? parseInt(this.formSearch.event.sync_id) !== 0 ? this.formSearch.event.sync_id : this.formSearch.event.id : '',
      start_time: this.formSearch.startTime ? this.formSearch.startTime.substring(0, 10) : '',
      end_time: this.formSearch.endTime ? this.formSearch.endTime.substring(0, 10) : '',
      page: 1,
      size: 10
    };
    exportStatistics(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private eventOptions = []
  // 获取事件列表
  private getCheckList(companyId:any) {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = companyId;
    cycleCheckList(params).then(res => {
      if (res.data != null && res.data.list && res.data.list.length > 0) {
        this.eventOptions = res.data.list;
      } else {
        this.eventOptions = [];
      }
    }).catch(err => {
      this.eventOptions = [];
      let msg = err.msg;
    });
  }

  private handleSizeChange(val:number) {
    this.listQuery.size = val;
    this.getRecordList();
  }
  private handleCurrentChange(val:number) {
    this.listQuery.page = val;
    this.getRecordList();
  }
  private selectBranch(branch:any) {
    this.checkboxDisabled = false;
    this.formSearch.name = branch.name;
    this.formSearch.branchCompanyId = branch.id;
    this.selecedtNameVisible = false;
  }

  private selectedNameHandle() {
    this.selecedtNameVisible = true;
  }
  private selecedtNameClose(val: boolean) {
    this.selecedtNameVisible = val;
  }

  private listLoading = false;
  private orderList = [];
  private getRecordList() {
    this.listLoading = true;
    const params = {
      branch_company_id: this.formSearch.branchCompanyId ? this.formSearch.branchCompanyId : UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      contain_branch: this.checkboxDisabled ? '1' : this.formSearch.containBranch ? '1' : '0',
      cycle_check_id: this.formSearch.event ? parseInt(this.formSearch.event.sync_id) !== 0 ? this.formSearch.event.sync_id : this.formSearch.event.id : '',
      start_time: this.formSearch.startTime ? this.formSearch.startTime.substring(0, 10) : '',
      end_time: this.formSearch.endTime ? this.formSearch.endTime.substring(0, 10) : '',
      // last_check_state: this.formSearch.state,
      page: this.listQuery.page,
      size: this.listQuery.size
    };
    this.orderList = [];
    branchStatistics(params).then(res => {
      this.listLoading = false;
      if (res && res.data) {
        this.orderList = res.data.list;
        this.listQuery.total = res.data.count || 0;
      } else {
        this.orderList = [];
      }
    }).catch(err => {
      this.listQuery.total = 0;
      this.listQuery.page = 1;
      this.listQuery.size = 10;
      this.listLoading = false;
      let msg = err.msg; // this.showErrorMsg(err.msg);
    });
  }
  // 点检统计
  private recordStatisticsHandle(val: any) {
    // 跳转 继续查找 当前选择的公司及其分公司记录
    this.checkboxDisabled = false;
    this.formSearch.name = val.company_name;
    this.formSearch.containBranch = true;
    this.formSearch.branchCompanyId = val.company_id;
    this.getRecordList();
  }
  // 点检记录
  private recordHandle(val: any) {
    let query:any = this.formSearch;
    query.startTime = this.formSearch.startTime ? this.formSearch.startTime.substring(0, 10) : '';
    query.endTime = this.formSearch.endTime ? this.formSearch.endTime.substring(0, 10) : '';
    query.last_check_state = 0;
    query.name = val.company_name;
    query.branchCompanyId = val.company_id;
    this.$router.push({
      path: '/Branch/checkRecordList',
      query: { 'pamars': JSON.stringify(query) }
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
